(function($, Drupal) {
  'use strict';

  Drupal.behaviors.profile = {
    attach: function(context) {
      $(once('profile-behavior', 'html', context)).each(function() {
        let profiles = document.querySelectorAll('.profile:not(.profile__img)');
        if (profiles) {
          for (let i = 0; i < profiles.length; i++) {
            let profileItem = profiles.item(parseInt(i));
            let bio = profileItem.querySelector('.bio');
            let button = profileItem.querySelector('.miax-link');
            let caret = profileItem.querySelector('.bi-caret-down-fill');
            if (button) {
              button.addEventListener('click', function() {
                if (bio.classList.contains('less')) {
                  bio.classList.remove('less');
                  button.innerHTML = 'Read less';
                  caret.classList.add('open');
                }
                else {
                  bio.classList.add('less');
                  button.innerHTML = 'Read more';
                  caret.classList.remove('open');
                }
              }, {passive: true});
            }

            // Remove Read more button if content is hidden with ellipsis.
            if (bio.scrollHeight <= bio.clientHeight) {
              $(button).parent().hide();
            }
            else {
              $(button).parent().show();
            }
          }
        }
      });
    }
  };
})(jQuery, Drupal);
